// // Login.jsx
// import { useState } from "react";
// import { handleLogin } from "./loginHandelSystem/hadelFunction";
// import Cookies from "js-cookie";
// import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

// export const Login = () => {
//   const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
//   const [username, setUsername] = useState("");
//   const [passphrase, setPassphrase] = useState("");
//   const [loginStatus, setLoginStatus] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   // If already authenticated via social or admin, bounce to home
//   const fbAuthToken = Cookies.get("fbauthToken");
//   const igAuthToken = Cookies.get("igauthtoken");
//   const authToken = Cookies.get("authToken");
//   const loginTime = Cookies.get("loginTime");

//   if (fbAuthToken || igAuthToken || (authToken && loginTime)) {
//     window.location.href = "https://namasvinexus.com";
//     return null;
//   }

//   const onLoginClick = async () => {
//     const ok = await handleLogin(username.trim(), passphrase.trim());
//     if (ok) {
//       setLoginStatus("success");
//       setShowModal(true);
//       setTimeout(() => (window.location.href = "https://namasvinexus.com"), 800);
//     } else {
//       setLoginStatus("failure");
//       setShowModal(true);
//     }
//   };

//   const onFacebookLogin = () => {
//     const url = `${authDomain}/auth/facebook?redirectTo=https://namasvinexus.com/auth/facebook/callback`;
//     window.location.assign(url);
//   };

//   const onInstagramLogin = () => {
//     const url = `${authDomain}/auth/instagram?redirectTo=https://namasvinexus.com/auth/instagram/callback`;
//     window.location.assign(url);
//   };

//   const closeModal = () => setShowModal(false);

//   return (
//     <div className="w-full bg-white ml-8 mt-20 p-16 items-center justify-center">
//       <main className="w-full flex flex-col items-start space-y-4">
//         <div className="flex items-center gap-5 mb-2">
//           <p className="text-xl font-semibold">Login:</p>
//           <input
//             type="text"
//             placeholder="Enter your username..."
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             className="border rounded-md px-4 py-2"
//           />
//         </div>
//         <div className="flex items-center gap-5 mb-2">
//           <p className="text-xl font-semibold">Passphrase:</p>
//           <input
//             type="password"
//             placeholder="Enter your passphrase..."
//             value={passphrase}
//             onChange={(e) => setPassphrase(e.target.value)}
//             className="border rounded-md px-4 py-2"
//           />
//         </div>
//         <button className="text-2xl border-2 bg-gray-800 text-white px-4 py-1" onClick={onLoginClick}>
//           Login
//         </button>

//         <div className="flex flex-col gap-2 mt-6">
//           <button className="text-lg border-2 bg-blue-600 text-white px-4 py-1 rounded mb-2" onClick={onFacebookLogin}>
//             Login with Facebook
//           </button>
//           <button className="text-lg border-2 bg-gradient-to-r from-pink-500 to-yellow-500 text-white px-4 py-1 rounded" onClick={onInstagramLogin}>
//             Login with Instagram
//           </button>
//         </div>
//       </main>

//       {showModal && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="relative w-[400px] p-8 bg-white rounded-lg shadow-lg">
//             {loginStatus === "success" ? (
//               <div className="flex flex-col items-center">
//                 <FaCheckCircle className="text-green-500 text-6xl mb-4" />
//                 <p className="text-2xl font-semibold text-green-600">Login successful!</p>
//                 <p className="mt-2 text-gray-500">Redirecting…</p>
//               </div>
//             ) : (
//               <div className="flex flex-col items-center">
//                 <FaTimesCircle className="text-red-500 text-6xl mb-4" />
//                 <p className="text-2xl font-semibold text-red-600">Login failed!</p>
//                 <p className="mt-2 text-gray-500">Please check your credentials and try again.</p>
//               </div>
//             )}
//             <button className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" onClick={closeModal}>
//               ✕
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";

export const Login = () => {
  const navigate = useNavigate();
  const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
  const [username, setUsername] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [loginStatus, setLoginStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // ✅ Static default admin credentials
  const DEFAULT_USER = {
    username: "namasvinexus",
    password: "Trishul@1010",
  };

  // Check auth status on mount
  useEffect(() => {
    const authToken = Cookies.get("authToken");
    const loginTime = Cookies.get("loginTime");

    console.log("[Login.js] Auth Check:", {
      authToken: !!authToken,
      loginTime: loginTime ? new Date(parseInt(loginTime)).toLocaleString() : null,
    });

    // Validate: authToken must exist and loginTime must be within 7 days
    const isLoginTimeValid = loginTime && Date.now() - parseInt(loginTime) < 7 * 24 * 60 * 60 * 1000;
    const hasValidAuth = authToken && isLoginTimeValid;

    console.log("[Login.js] Auth Result:", { hasValidAuth, isLoginTimeValid });

    if (hasValidAuth) {
      // User is already logged in, redirect to dashboard
      navigate("/", { replace: true });
    }
    setIsCheckingAuth(false);
  }, [navigate]);

  // Show nothing while checking auth (prevent flash of login form)
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg font-medium">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Handle login
  const onLoginClick = async () => {
    const trimmedUsername = username.trim();
    const trimmedPassphrase = passphrase.trim();

    let loginResult = false;

    // ✅ Static check for admin
    if (
      trimmedUsername === DEFAULT_USER.username &&
      trimmedPassphrase === DEFAULT_USER.password
    ) {
      loginResult = true;

      // Set authentication tokens
      // Using the real Facebook token from Firebase DB for facebook:122116971392403029 (Trishul Koli)
      const realFBToken = "EAAfu4stBpQYBPeHxnGejWGH8dhFm4zjDPQphLHAmKqfnjH6moDSw357Ou7DIZCS9ZAXAu3CjnIZAkODNhUd2DrtYFqE93JKXLbzPagaynKdC3UXMZAId4wZBTVilKWDHRHZASTNgdeWGwmuOuUWbPmVqQIh7ex47iHKkdxCltHvZCBRZBaZBfWiSIP4LHgZC4HArjD";
      const adminToken = "NAMASVI_ADMIN_" + Date.now();

      Cookies.set("authToken", adminToken, { expires: 7 }); // 7 days
      Cookies.set("loginTime", Date.now(), { expires: 7 });
      Cookies.set("fbauthToken", realFBToken, { expires: 7 }); // Use real FB token

      // Set localStorage for faster future auth checks
      localStorage.setItem("isAuthenticated", "true");
    }

    if (loginResult) {
      setLoginStatus("success");
      setShowModal(true);

      // Use navigate instead of window.location.href for SPA navigation
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1500);
    } else {
      setLoginStatus("failure");
      setShowModal(true);
    }
  };

  const closeModal = () => setShowModal(false);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50 px-6">
      <div className="w-full max-w-md bg-white shadow-2xl rounded-2xl p-8 space-y-6">
        {/* Logo/Header */}
        <div className="text-center mb-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            NAMASVI<span className="text-blue-600">-Nexus</span>
          </h1>
          <div className="w-16 h-1 bg-blue-600 mx-auto mb-4"></div>
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-800">Login</h2>
        <p className="text-center text-gray-500 text-sm">
          Enter your credentials to access the dashboard
        </p>

        {/* Username */}
        <div className="space-y-2">
          <label className="text-gray-700 font-medium text-sm">
            Username / Email
          </label>
          <input
            type="text"
            placeholder="Enter your username..."
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
          />
        </div>

        {/* Password */}
        <div className="space-y-2">
          <label className="text-gray-700 font-medium text-sm">Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password..."
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 pr-12 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
            >
              {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
            </button>
          </div>
        </div>

        {/* Login Button */}
        <button
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg shadow-md transition duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
          onClick={onLoginClick}
        >
          Login
        </button>

        {/* Footer */}
        <p className="text-center text-gray-400 text-xs mt-6">
          © 2025 Namasvi-Nexus. All rights reserved.
        </p>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="relative w-[400px] p-8 bg-white rounded-xl shadow-2xl animate-scaleIn">
            {loginStatus === "success" ? (
              <div className="flex flex-col items-center text-center">
                <FaCheckCircle className="text-green-500 text-6xl mb-4" />
                <p className="text-2xl font-semibold text-green-600">
                  Login successful!
                </p>
                <p className="mt-2 text-gray-500">Redirecting...</p>
              </div>
            ) : (
              <div className="flex flex-col items-center text-center">
                <FaTimesCircle className="text-red-500 text-6xl mb-4" />
                <p className="text-2xl font-semibold text-red-600">
                  Login failed!
                </p>
                <p className="mt-2 text-gray-500">
                  Invalid username or password.
                </p>
              </div>
            )}
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl"
              onClick={closeModal}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
